"use client";

import { c as _c } from "react/compiler-runtime";
import SignInForm from "@/components/sign-in-form";
export default function SignInPage() {
  const $ = _c(1);
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = <SignInForm />;
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  return t0;
}